// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gvgEKoSRudgFn3fFN5k8 {

    font-size: 1rem;

    line-height: 1.5rem;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.jDmXQVo4FyysFD2b8czo {

    font-size: 0.875rem;

    line-height: 1.25rem;

    --tw-text-opacity: 1;

    color: rgb(149 149 149 / var(--tw-text-opacity, 1))
}

.TOpCIPYZr_sUMzbuX68v {

    font-size: 11px;

    --tw-text-opacity: 1;

    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.mQrY2xZ_kK2XLotvgmIa {

    height: 45px
}

.h5VMH1DQ1kGA_ZeXovnb {

    display: flex;

    flex-wrap: wrap;

    gap: 16px 16px
}
.rqo6OOmEXvkSKYMWB1UN {

    resize: none
}

.dVXjcJQAfGNAEKS2MAFJ .ant-checkbox-inner {

    --tw-border-opacity: 1 !important;

    border-color: rgb(149 149 149 / var(--tw-border-opacity, 1)) !important
}

.YBlTKCUHl2_ZeRy39zyw .ant-form-item-additional {

    margin-bottom: 0.75rem
}

.mP0rN_XfZ25RN1wx7FPu {

    height: 38px;

    width: 120px;

    --tw-border-opacity: 1;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}

.mP0rN_XfZ25RN1wx7FPu:hover {

    --tw-border-opacity: 1 !important;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important
}

.akZnxPvvn_xkcLJrEN7D {

    height: 38px;

    width: 120px;

    --tw-bg-opacity: 1;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.akZnxPvvn_xkcLJrEN7D:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/Pledge/CDDForm/CDDForm.module.css"],"names":[],"mappings":"AACE;;IAAA,eAA0C;;IAA1C,mBAA0C;;IAA1C,gBAA0C;;IAA1C,oBAA0C;;IAA1C;AAA0C;;AAI1C;;IAAA,mBAA4B;;IAA5B,oBAA4B;;IAA5B,oBAA4B;;IAA5B;AAA4B;;AAI5B;;IAAA,eAAgC;;IAAhC,oBAAgC;;IAAhC;AAAgC;;AAIhC;;IAAA;AAAe;;AAIf;;IAAA,aAAqC;;IAArC,eAAqC;;IAArC;AAAqC;AAGrC;;IAAA;AAAkB;;AAIlB;;IAAA,iCAAuB;;IAAvB;AAAuB;;AAIvB;;IAAA;AAAW;;AAIX;;IAAA,YAAwE;;IAAxE,YAAwE;;IAAxE,sBAAwE;;IAAxE,0DAAwE;;IAAxE,kBAAwE;;IAAxE,4DAAwE;;IAAxE,oBAAwE;;IAAxE,qBAAwE;;IAAxE,mBAAwE;;IAAxE,sBAAwE;;IAAxE,oBAAwE;;IAAxE;AAAwE;;AAIxE;;IAAA,iCAA8C;;IAA9C,qEAA8C;;IAA9C,6BAA8C;;IAA9C,uEAA8C;;IAA9C,+BAA8C;;IAA9C;AAA8C;;AAI9C;;IAAA,YAAyD;;IAAzD,YAAyD;;IAAzD,kBAAyD;;IAAzD,0DAAyD;;IAAzD,oBAAyD;;IAAzD,qBAAyD;;IAAzD,mBAAyD;;IAAzD,sBAAyD;;IAAzD,oBAAyD;;IAAzD;AAAyD;;AAIzD;;IAAA,6BAA8B;;IAA9B,qEAA8B;;IAA9B,+BAA8B;;IAA9B;AAA8B","sourcesContent":[".filterLable {\n  @apply font-medium text-base text-gray-500;\n}\n\n.fieldName {\n  @apply text-gray-300 text-sm;\n}\n\n.fieldSubName {\n  @apply text-gray-400 text-[11px];\n}\n\n.customSelect {\n  @apply h-[45px];\n}\n\n.radioGroup {\n  @apply flex flex-wrap gap-[16px_16px];\n}\n.textAreaNoResize {\n  @apply resize-none;\n}\n\n.customForm :global(.ant-checkbox-inner) {\n  @apply !border-gray-300;\n}\n\n.container :global(.ant-form-item-additional) {\n  @apply mb-3;\n}\n\n.clearButton {\n  @apply bg-white text-primary border-primary px-6 py-2 w-[120px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-primary !border-primary;\n}\n\n.applyButton {\n  @apply bg-primary text-white px-6 py-2 w-[120px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-primary !text-white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterLable": `gvgEKoSRudgFn3fFN5k8`,
	"fieldName": `jDmXQVo4FyysFD2b8czo`,
	"fieldSubName": `TOpCIPYZr_sUMzbuX68v`,
	"customSelect": `mQrY2xZ_kK2XLotvgmIa`,
	"radioGroup": `h5VMH1DQ1kGA_ZeXovnb`,
	"textAreaNoResize": `rqo6OOmEXvkSKYMWB1UN`,
	"customForm": `dVXjcJQAfGNAEKS2MAFJ`,
	"container": `YBlTKCUHl2_ZeRy39zyw`,
	"clearButton": `mP0rN_XfZ25RN1wx7FPu`,
	"applyButton": `akZnxPvvn_xkcLJrEN7D`
};
export default ___CSS_LOADER_EXPORT___;
